export class Dropdown {
  static isOnPage() {
    return document.getElementsByName('js-dropdown');
  }

  onDeactivateDropdown($dropdown, $dropdwonContent, $dropdownLink) {
    $dropdown.find('.arrow').remove();
    $dropdwonContent.removeClass('submenu--is-active');
    $dropdownLink.removeClass('opened');
    $dropdown.removeClass('js-dropdown--is-active');
  }

  showArrow($dropdown, $dropdownLink) {
    let $arrow = $dropdown.find('.arrow');
    if (!$arrow.length) {
      $arrow = $('<div class="arrow"></div>');
      $dropdown.append($arrow);
    }
    $arrow.css({
      left: $dropdownLink[0].offsetLeft + ($dropdownLink.width() / 2) - ($arrow.width() / 2)
    });
    if ($dropdown.find('.js-is-show-more-dropdown').length) {
      const $dropdownContent = $dropdown.find('.js-dropdown-content');
      const $siteName = $('.js-site-name');
      const siteNameBottom = $siteName.offset().top + $siteName.find('a').height();
      const middle = $siteName.offset().left + ($siteName.width() / 2);
      const dropdownsLeft = middle - ($dropdownContent.width() / 2);

      $arrow.offset({
        left: middle - ($arrow.width() / 2),
        top: siteNameBottom
      });
      $dropdownContent.offset({
        left: dropdownsLeft,
        top: $arrow.offset().top + $arrow.height() - 1
      });
    }
  }

  onActivateDropdown($dropdown, $dropdownLink) {
    const $dropdownContent = $dropdown.find('.js-dropdown-content');
    if ($dropdown.hasClass('js-country-selector')) {
      const width = $dropdown.parents('.container').width();
      $dropdownContent.css({ width });
    }
    $dropdown.addClass('js-dropdown--is-active');
    $dropdownContent.addClass('submenu--is-active');
    $dropdownLink.addClass('opened');
    this.showArrow($dropdown, $dropdownLink);
    $dropdown.on('mouseleave', () => {
      if (window.innerWidth >= 992 || !$dropdownLink.hasClass('menu-item-expand')) {
        this.onDeactivateDropdown($dropdown, $dropdownContent, $dropdownLink);
      }
      if (window.innerWidth >= 992 && $dropdownLink.hasClass('menu-item-expand')) {
        $('body').removeClass('body-backdrop');
      }
    });
  }

  constructor() {
    $.each($('.js-dropdown'), (index, dropdown) => {
      const $dropdown = $(dropdown);
      const $dropdownLink = $dropdown.find('.js-dropdown-link');
      $dropdownLink.hover(() => {
        if (window.innerWidth >= 992 || !$dropdownLink.hasClass('menu-item-expand')) {
          this.onActivateDropdown($dropdown, $dropdownLink);
        }
      });
      $dropdownLink.click(() => {
        if (window.innerWidth < 992 && $dropdownLink.hasClass('menu-item-expand')) {
          if ($dropdownLink.hasClass('opened')) {
            return this.onDeactivateDropdown($dropdown, $dropdown.find('.js-dropdown-content'), $dropdownLink);
          }
          this.onActivateDropdown($dropdown, $dropdownLink);
        }
      });
    });
  }
}

